<template>
  <Base
    :detail="detail"
    v-if="prizes && prizes.length > 0"
    :show-loading="showLoading"
  >
    <div class="points">
      <div class="current-num">{{detail.join_num}} people have participated in the activity</div>
      <div class="my-info">
        <div class="info-head">
          <img :src="avatar" />
        </div>
        <div class="info-coins">
          <span>{{coins}}</span> Coins
        </div>
        <div class="info-count">
          Cumulative check-in<br />
          <span>{{detail.sign_days}}</span> days
        </div>
      </div>
      <div class="sign-in" @click="signIn">
        <img src="https://sanyglobal-img.sany.com.cn/static/img/signIn.svg" />
      </div>
      <div class="explain">Spend {{detail.config.coin_draw_num}} gold coins to draw</div>
      <div class="btn" @click="draw">Draw Now</div>
    </div>
    <PrizeDetail :detail="detail" :myAwards="myAwards" />
  </Base>
</template>

<script>
import { LuckDrawMixin } from "@/mixins/Luckdraw";
import { signIn } from "@/util/data";
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  mixins: [LuckDrawMixin],
  components: {
    
  },
  data() {
    return {
      isSign:true,
      prizes: [],
      defaultConfig: { gutter: "1px", offsetDegree: 180 },
      prizeDefault: [],
      prizeReSort: [],
      coins:0,
      avatar:''
    };
  },
  methods: {
    handleData(data) {
      let temp = { ...data };
      if (!temp.background_img)
        temp.background_img = require("@/assets/img/award/beij.jpg");
      if (!temp.brief_img)
        temp.brief_img = require("@/assets/img/award/title.png");
      this.detail = { ...temp };
      this.coins = this.detail.coins;
      this.myAwards = [...this.detail.my_awards];
      this.chance = this.detail.remaining_num || 0;
      this.prizeDefault = [...temp.prizes];
      this.prizeReSort = [...this.resort(this.prizeDefault)];
      this.prizes = this.prizeReSort.map(item => ({
        imgs: [
          {
            src: item.image,
            width: 150 * baseSize + "px"
          }
        ],
        background: "#eeffdf"
      }));
      //获取用户头像(Google & Facebook登录)
      if (window.localStorage.getItem("userDetail")) {
        var info = JSON.parse(window.localStorage.getItem("userDetail"));
        if (info.avatar) {
          this.avatar = info.avatar;
        }
        return;
      }
    },
    resort(list) {
      if (list.length === 4) {
        const [A, B, C, D] = list;
        return [A, B, C, D, B, C];
      } else if (list.length === 5) {
        const [A, B, C, D, E] = list;
        return [A, B, D, E, C, D];
      } else if (list.length === 6) {
        const [A, B, C, D, E, F] = list;
        return [A, B, D, F, C, E];
      } else if (list.length === 7) {
        const [A, B, C, D, E, F, G] = list;
        return [A, B, C, F, G, D, E, F];
      } else if (list.length === 8) {
        const [A, B, C, D, E, F, G, H] = list;
        return [A, B, C, F, H, D, E, G];
      }
    },
    draw() {
      if(!this.checkLogin()) return ;
      const endTime = this.detail.end_time
        ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
        : "";
      const nowTime = new Date().getTime();
      if (!endTime || endTime < nowTime) {
        this.showMessage("Game over!");
        return;
      }
      if (this.chance < 1) {
        this.showMessage("No chance today, come back tomorrow.!");
        return;
      }
      if(this.coins<this.detail.config.coin_draw_num){
        this.showMessage("No chance today, come back tomorrow.!");
        return;
      }
      this.getResult();
    },
    handleError(){
      // const index=this.getIndex(0);
      // this.$refs.LuckyWheel.stop(index);
    },
    // getIndex(id) {
    //   let temp = [];
    //   this.prizeReSort.forEach((item, index) => {
    //     if (item.id === id) temp.push(index);
    //   });
    //   const len = temp.length;
    //   if (len < 1 && id !== 0) return this.getIndex(0);
    //   else if (len === 1) return temp[0];
    //   else if (len > 1) return temp[Math.floor(len * Math.random())];
    // },
    handleResult(data) {
      this.chance -= 1;
      this.coins = this.coins - this.detail.config.coin_draw_num;
      const { id, title, level, image } = data.award;
      if(id) this.myAwards.unshift({ id, title, level, image });
      this.showLoading = false;
      if (id === 0) {
        this.showResult({ type: 1 });
      } else {
        this.showResult({ type: 3, title, level });
      }
    },
    endCallback(prize) {
      console.log("endCallback",prize)
    },
    signIn() { //点击签到
      if(!this.checkLogin()) return ;
      const endTime = this.detail.end_time
        ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
        : "";
      const nowTime = new Date().getTime();
      if (!endTime || endTime < nowTime) {
        this.showMessage("Game over!");
        return;
      }
      if(!this.isSign) {
        this.showMessage("You have signed in. Please come back tomorrow!");
        return;
      }
      this.isSign = false;
      let token = this.$store.state.token || window.localStorage.getItem("token");
      signIn(
        {activity_id: this.$route.params.id},
        token
      ).then(res => {
          if (res.code === 1) {
            this.coins = this.coins+this.detail.config.coin_sign_num; 
            this.showMessage("Success!");
          } else {
            this.showLoading = false;
            this.handleError();
            this.showMessage(res.msg || "Failed!");
          }
        })
        .catch(err => {
          const msg = typeof err === "object" ? JSON.stringify(err) : err;
          this.showMessage(msg === "{}" || !msg ? "Failed!" : msg);
          this.showLoading = false;
          this.handleError();
        });
    },  
  }
};
</script>

<style scoped lang="scss">
.points{
  padding-bottom: 30px;
  .current-num{
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 20px;
  }
  .my-info{
    width: calc(100% - 30px);
    margin: 15px auto;
    background: rgba(255,255,255,0.25);
    border-radius: 8px;
    backdrop-filter: blur(10px);
    padding: 25px 18px;
    box-sizing: border-box;
    overflow: hidden;
    .info-head{
      width: 50px;
      height: 50px;
      background: rgba(0,0,0,0.00);
      border: 1px solid #ffffff;
      border-radius: 50%;
      float: left;
      overflow: hidden;
    }
    .info-coins{
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #ffe971;
      line-height: 50px;
      margin: 0 38px 0 15px;
      float: left;
      span{
        color: #FFE971;
      }
    }
    .info-count{
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      line-height: 20px;
      float: left;
      margin-top: 5px;
      span{
        color: #FFE971;
      }
    }
  }
  .sign-in{
    width: 110px;
    height: 110px;
    border-radius: 50%;
    cursor: pointer;
    margin: 52px auto;
    img{
      width: 100%;
    }
  }
  .explain{
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 20px;
  }
  .btn{
    width: 200px;
    height: 40px;
    background: #f6b434;
    border-radius: 20px;
    margin:20px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/LuckyPoints.vue